var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview_fill_list",class:{'vip_preview_btn': _vm.userInfo && _vm.userInfo.can_query},on:{"click":_vm.viewFillDetail}},[_vm._v(" 预览志愿 "),_c('span',[_vm._v(_vm._s(_vm.selectTotalNum))])])
}
var staticRenderFns = []

export { render, staticRenderFns }